export class AppError extends Error {
  constructor(code, message, options = {}) {
    super(message)
    this.name = 'AppError'
    this.code = code
    this.category = options.category || 'unknown'
    this.retryable = Boolean(options.retryable)
    this.cause = options.cause
    this.correlationId = options.correlationId || null
  }
}

export function serializeError(error) {
  return {
    code: error?.code || 'unknown',
    category: error?.category || 'unknown',
    retryable: Boolean(error?.retryable),
    message: String(error?.message || error || '未知错误').slice(0, 240),
    correlationId: error?.correlationId || null,
  }
}
